function resetToFirstSwatchPanel() {
  var allActiveSwatchGroups = document.querySelectorAll('.variantsSwatchGroups > .variantSwatchGroupWrapper');
  var i;
  for (i = 0; i < allActiveSwatchGroups.length; i++) {
    allActiveSwatchGroups[i].classList.remove('active');
  }
  document.querySelectorAll(('.variantsSwatchGroups.active > .variantSwatchGroupWrapper'))[0].classList.add('active');

  activeStep = 1;
  var numberOfSteps = document.querySelectorAll('.variantsSwatchGroups.active')[0].getAttribute('data-totalsteps');
  if(numberOfSteps > 1) {
    document.getElementById('confirmVariantModal').style.display = 'none';
    document.getElementById('nextStepVariantModal').style.display = 'inline-flex';
  } else {
    document.getElementById('confirmVariantModal').style.display = 'inline-flex';
    document.getElementById('nextStepVariantModal').style.display = 'none';
  }
  buildStepProgressUI(numberOfSteps);
  checkForMultipleOptions();
}

function buildStepProgressUI(numberOfSteps) {
  var i, j, swatchReference, thisSelectedSwatch;
  var stepProgressOutput = '';
  for (i=1; i<=numberOfSteps; i++) {
    swatchReference = '';
    stepProgressOutput += '<li data-pagination="'+i+'"';
    if(i<activeStep) {
      stepProgressOutput += ' class="active"';
    } else if (i == activeStep) {
      stepProgressOutput += ' class="current"';
    }
    stepProgressOutput += '>';

    // check if this step has a selected swatch:
    var allActiveSwatchGroups = document.querySelectorAll('.variantsSwatchGroups.active > .variantSwatchGroupWrapper[data-step="'+i+'"]');
    if(allActiveSwatchGroups != null) {
      for (j = 0; j < allActiveSwatchGroups.length; j++) {
        thisSelectedSwatch = allActiveSwatchGroups[j].querySelector('.swatchSelection.active');
        if(thisSelectedSwatch != null) {
          swatchReference = thisSelectedSwatch.getAttribute('data-previewimage');
        }
      }
    }
    if(swatchReference == '') {
      stepProgressOutput += i;
    } else {
      stepProgressOutput += '<img src="'+swatchReference+'">';
    }
    stepProgressOutput += '</li>';
  }
  document.getElementById('stepProgress').innerHTML = stepProgressOutput;

}

function nextStepVariantModal() {
  if((usingAccordion) && (activeStep == 1) && (!(accordionHeaderClicked))) {
    // no accordion open, so expand the first item so the content is visible:
    document.querySelector('#accordionVariantWrapper .swatchAccordionHeader:first-child').click();
  } else {

    var allActiveSwatchGroups = document.querySelectorAll('.variantsSwatchGroups > .variantSwatchGroupWrapper');
    var i;
    for (i = 0; i < allActiveSwatchGroups.length; i++) {
      allActiveSwatchGroups[i].classList.remove('active');
    }
    clearSwatchPreview();
    activeStep ++;

    if (usingAccordion) {
      if (document.getElementById('variantModal')) {
        document.getElementById('variantModal').setAttribute('data-step', activeStep);
      }
    }

    var newGroup = document.querySelectorAll(('.variantsSwatchGroups.active > .variantSwatchGroupWrapper[data-step="'+activeStep+'"]'));
    if(newGroup !== null) {
      if(newGroup.length > 0) {
        // it might be null if there are only 2 swatch groups but 3 options, we still want the third step to show the third option
        newGroup[0].classList.add('active');
      }
    }
    var numberOfSteps = document.querySelectorAll('.variantsSwatchGroups.active')[0].getAttribute('data-totalsteps');
    if(activeStep >= numberOfSteps) {
      document.getElementById('confirmVariantModal').style.display = 'inline-flex';
      document.getElementById('nextStepVariantModal').style.display = 'none';
    } else {
      document.getElementById('confirmVariantModal').style.display = 'none';
      document.getElementById('nextStepVariantModal').style.display = 'inline-flex';
    }
    // re-activate the swatch if been here before:
    updateSwatchPreview();
    buildStepProgressUI(numberOfSteps);
    checkForMultipleOptions();
  }
}

function stepPaginationClick(e) {
  if((usingAccordion) && (activeStep == 1) && (!(accordionHeaderClicked))) {
    // no accordion open, so expand the first item so the content is visible:
    document.querySelector('#accordionVariantWrapper .swatchAccordionHeader:first-child').click();
  } else {
    if(!(e.target.closest('li').classList.contains('current'))) {
      // -1 as the function moves it along to the next step:
      activeStep = parseInt(e.target.closest('li').getAttribute('data-pagination'))-1;
      nextStepVariantModal();
    }
  }
}

function checkForMultipleOptions() {
  var i;
  var multipleOptionDropdowns = document.querySelectorAll('.product-form__input.multipleOption');
  var numberOfSteps = document.querySelectorAll('.variantsSwatchGroups.active')[0].getAttribute('data-totalsteps');
  if(multipleOptionDropdowns != null) {
    if(numberOfSteps > 1) {
      for (i = 0; i < multipleOptionDropdowns.length; i++) {
        if(i == (activeStep-1)) {
          multipleOptionDropdowns[i].classList.remove('notThisStep');
        } else {
          multipleOptionDropdowns[i].classList.add('notThisStep');
        }
      }
    }
  }
}

function showVariantModal() {
  // clear error messages if showing:
  document.querySelector('.product-form__error-message-wrapper').toggleAttribute('hidden', true);
  document.querySelector('.product-form__error-message').textContent = "";
  document.getElementById('confirmVariantError').innerHTML = "";
  resetToFirstSwatchPanel();
  document.documentElement.classList.add("variantModalActive");
  //document.getElementById('variantModal').scrollIntoView({ behavior: "instant" });
}


function clearVariantModal() {
  modalOptionsSelected = false;
  activeStep = 1;
  clearSwatchPreview();
  resetToFirstSwatchPanel();

  var allSwatchSelectors = document.querySelectorAll('.swatchSelection');
  var i;
  for (i = 0; i < allSwatchSelectors.length; i++) {
    allSwatchSelectors[i].classList.remove('active');
  }
  var allSwatchInputs = document.querySelectorAll('.activeSwatchChoice');
  for (i = 0; i < allSwatchInputs.length; i++) {
    allSwatchInputs[i].value = '';
  }
  var allSwatchHeadings = document.querySelectorAll('.variantSwatchGroupWrapper .form__label');
    for (i = 0; i < allSwatchHeadings.length; i++) {
    allSwatchHeadings[i].classList.remove('error');
  }
}


function clearSwatchPreview() {
  if(document.getElementById('confirmVariantError')) {
    document.getElementById('confirmVariantError').innerHTML = '';
  }
  if(document.getElementById('swatchSelectionPreview')) {
    document.getElementById('swatchSelectionPreview').innerHTML = '';
  }
}

function zoomPreviewImage(e) {
  e.target.closest('.previewEntity').classList.toggle('expanded');
}

function setSimpleSwatchPreview(element, sampleImage) {
    var htmlOutput = '';  

      if(sampleImage != "") {
        htmlOutput += '<div class="previewEntity">';
        htmlOutput += '<div class="previewImageWrapper loading"><div class="loading-overlay"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-accent)"></circle></svg></div>';
        htmlOutput += '<div class="previewImage"><img src="'+sampleImage+'"></div></div>';
        htmlOutput += '<div class="previewImageZoom"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M4.2,6.3h4 M10,10l3,3 M11.5,6.2c0,2.9-2.4,5.2-5.2,5.2S1,9.1,1,6.2S3.4,1,6.2,1S11.5,3.4,11.5,6.2z" stroke="var(--color-accent)" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" /></g><g id="previewZoomPlusLine"><path d="M6.2,4.3v4" stroke="var(--color-accent)" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" /></g></svg></div>';
        htmlOutput += '</div>';
      }

    if (document.querySelector('.simpleSwatchSelectionPreview') !== null) {
      element.closest('.product-form__input--color').nextElementSibling.innerHTML = htmlOutput;
      if(document.querySelector('.previewImageZoom') !== null) {
        // (re)add click event for zoom item
        element.closest('.product-form__input--color').nextElementSibling.querySelector('.previewImageZoom').onclick = zoomPreviewImage;
      }
    }

}

function updateSimpleSwatchPreview() {
  if(event.target.closest('.product-swatch-option')) {
    var htmlOutput = '';  
      const thisSwatchData = event.target.closest('.product-swatch-option').getAttribute("data-previewimage");
      if(thisSwatchData != "") {
        htmlOutput += '<div class="previewEntity">';
        htmlOutput += '<div class="previewImageWrapper loading"><div class="loading-overlay"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-accent)"></circle></svg></div>';
        htmlOutput += '<div class="previewImage"><img src="'+thisSwatchData+'"></div></div>';
        htmlOutput += '<div class="previewImageZoom"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M4.2,6.3h4 M10,10l3,3 M11.5,6.2c0,2.9-2.4,5.2-5.2,5.2S1,9.1,1,6.2S3.4,1,6.2,1S11.5,3.4,11.5,6.2z" stroke="var(--color-accent)" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" /></g><g id="previewZoomPlusLine"><path d="M6.2,4.3v4" stroke="var(--color-accent)" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" /></g></svg></div>';
        htmlOutput += '</div>';
      }
    if (document.querySelector('.simpleSwatchSelectionPreview') !== null) {
      event.target.closest('.product-form__input--color').nextElementSibling.innerHTML = htmlOutput;
      if(document.querySelector('.previewImageZoom') !== null) {
        // (re)add click event for zoom item
        event.target.closest('.product-form__input--color').nextElementSibling.querySelector('.previewImageZoom').onclick = zoomPreviewImage;
      }
    }
  }
}

function updateSwatchPreview() {
  document.getElementById('confirmVariantError').innerHTML = '';
  var allActiveSwatchGroups = document.querySelectorAll('.variantsSwatchGroups.active > .variantSwatchGroupWrapper.active');
  var htmlOutput = '';
  var previewImage = '';
  var i, thisTitle, thisSelectedSwatch, previewImage;
  for (i = 0; i < allActiveSwatchGroups.length; i++) {
    thisTitle = allActiveSwatchGroups[i].querySelector('.form__label').getAttribute('data-optionname');
    thisSelectedSwatch = allActiveSwatchGroups[i].querySelector('.swatchSelection.active');
    if(thisSelectedSwatch != null) {
      previewImage = thisSelectedSwatch.getAttribute('data-previewimage');
      htmlOutput += '<div class="previewEntity">';
      htmlOutput += '<div class="previewImageWrapper loading"><div class="loading-overlay"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-accent)"></circle></svg></div>';
      htmlOutput += '<div class="previewImage"><img src="'+previewImage+'"></div></div>';
      htmlOutput += '<div class="previewText"><strong>'+thisTitle+':</strong> '+thisSelectedSwatch.getAttribute('data-name')+'</div>';
      htmlOutput += '<div class="previewImageZoom"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M4.2,6.3h4 M10,10l3,3 M11.5,6.2c0,2.9-2.4,5.2-5.2,5.2S1,9.1,1,6.2S3.4,1,6.2,1S11.5,3.4,11.5,6.2z" stroke="var(--color-accent)" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" /></g><g id="previewZoomPlusLine"><path d="M6.2,4.3v4" stroke="var(--color-accent)" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" /></g></svg></div>';
      htmlOutput += '</div>';
    }
  }
  document.getElementById('swatchSelectionPreview').innerHTML = htmlOutput;
  if(previewImage != '') {
    // update the pagination item:
    document.querySelector('#stepProgress li[data-pagination="'+activeStep+'"]').innerHTML = '<img src="'+previewImage+'">';
  }
  if(document.querySelector('.previewImageZoom') !== null) {
    // (re)add click event for zoom item
    //document.getElementById('previewImageZoom').onclick = zoomPreviewImage;


        document.querySelector('.previewImageZoom').onclick = zoomPreviewImage;
      


  }
}

function modalSlideOutComplete() {
  document.getElementById("variantModalSlideIn").removeEventListener("transitionend", modalSlideOutComplete, false);
  document.documentElement.classList.remove("variantModalSlideOutAnimation");
  document.documentElement.classList.remove("variantModalActive");
}

function confirmVariantModal(e) {
  modalOptionsSelected = true;
  // look for all active groups and confirm there's a choice for each group:
  var allSwatchGroups = document.querySelectorAll('.variantsSwatchGroups.active > .variantSwatchGroupWrapper');
  var i, thisChoice, thisErrorName;
  var thisFirstError = '';
  var firstStepError = 0;
  for (i = 0; i < allSwatchGroups.length; i++) {
    thisChoice = allSwatchGroups[i].querySelector('.activeSwatchChoice');
    if(thisChoice.value == '') {
      modalOptionsSelected = false;
      allSwatchGroups[i].querySelector('.form__label').classList.add("error");
      thisErrorName = thisChoice.name;
      if(thisErrorName.indexOf("[") !== -1) {
        thisErrorName = thisChoice.name.split("[")[1].replace(']','');
      }
      if(thisFirstError == '') {
        thisFirstError = thisErrorName;
        firstStepError = i;
      }
       
    }
  }
  if(thisFirstError != '') {
    e.preventDefault();
    document.getElementById('confirmVariantError').innerHTML = '<p>Please select '+thisFirstError+'</p>';
    // make that step active: (loop is zero based, but steps 1 based, but the function moves it on 1, so will work)
    activeStep = firstStepError;
    nextStepVariantModal()

  }

  if (modalOptionsSelected) {
    // start animation out - and clean up once it's out of view:
    document.getElementById("variantModalSlideIn").addEventListener("transitionend", modalSlideOutComplete, false);  
    document.documentElement.classList.add("variantModalSlideOutAnimation");  
  }
}

function hideVariantModal() {
  // start animation out - and clean up once it's out of view:
  document.getElementById("variantModalSlideIn").addEventListener("transitionend", modalSlideOutComplete, false);  
  document.documentElement.classList.add("variantModalSlideOutAnimation"); 
}

function checkForStockLevel(activeVariantID) {
  if(stockLevels.hasOwnProperty(activeVariantID)) {
    if(stockLevels[activeVariantID] > 0) {
      var newStockLevel = stockLevels[activeVariantID]+" "+document.getElementById("inStockLabel").getAttribute('data-suffix');
      document.getElementById("inStockLabel").innerHTML = newStockLevel;
      document.getElementById("inStockLabel").style.display = 'block';
      if(document.getElementById("modalStockLevelLabel")) {
        document.getElementById("modalStockLevelLabel").innerHTML = newStockLevel;
        document.getElementById("modalStockLevelLabel").style.display = 'block';
      }
    } else {
      document.getElementById("inStockLabel").style.display = 'none';
      if(document.getElementById("modalStockLevelLabel")) {
        document.getElementById("modalStockLevelLabel").style.display = 'none';
      }
    }
  } else {
    document.getElementById("inStockLabel").style.display = 'none';
    if(document.getElementById("modalStockLevelLabel")) {
      document.getElementById("modalStockLevelLabel").style.display = 'none';
    }
  }
}

function checkForLeadTime(activeVariantID) {
  if(leadTimes.hasOwnProperty(activeVariantID)) {
    if(leadTimes[activeVariantID] == "in_stock") {
      document.getElementById('productLeadTime').value = '';
      document.getElementById("leadTimeLabel").style.display = 'none';
      document.getElementById("productInStockBadge").style.display = 'inline-flex';
    } else {
      document.getElementById("productInStockBadge").style.display = 'none';
      document.getElementById("leadTimeLabel").innerHTML = document.getElementById("leadTimeLabel").getAttribute('data-prefix')+leadTimes[activeVariantID];
      document.getElementById("leadTimeLabel").style.display = 'block';
      document.getElementById('productLeadTime').value = leadTimes[activeVariantID];
    }
  } else {
    document.getElementById("productInStockBadge").style.display = 'none';
    document.getElementById('productLeadTime').value = '';
    document.getElementById("leadTimeLabel").style.display = 'none';
  }
}

function activeSwatchGroupResponse() {
  const response = JSON.parse(this.responseText);
  if(usingAccordion) {
    document.querySelector('#accordionVariantWrapper .swatchAccordionHeader[data-label="'+storedActiveDataHeader+'"]').insertAdjacentHTML('beforeend', response["variant-swatch-group"]);
    document.querySelector('#accordionVariantWrapper .swatchAccordionHeader[data-label="'+storedActiveDataHeader+'"]').classList.remove('loading');
  } else {
    document.getElementById('dynamicallyLoadedSwatchGroups').insertAdjacentHTML('beforeend',response["variant-swatch-group"]);
    document.getElementById('dynamicallyLoadedSwatchGroups').classList.remove('loading');
  }
  updateActiveSwatchGroup(storedActiveVariantId);
  // apply click events to new elements:
  setUpSwatchClickHandlers();
}

function loadActiveSwatchGroup(activeVariantID) {
  if(usingAccordion) {
    // set active accordion header:
    var swatchAccordionSelectors = document.querySelectorAll('#accordionVariantWrapper .swatchAccordionHeader');
    var i;
    for (i = 0; i < swatchAccordionSelectors.length; i++) {
      swatchAccordionSelectors[i].classList.remove('active');
    }
    document.querySelector('#accordionVariantWrapper .swatchAccordionHeader[data-label="'+storedActiveDataHeader+'"]').closest('.swatchAccordionHeader').classList.add('active');
    document.querySelector('#accordionVariantWrapper .swatchAccordionHeader[data-label="'+storedActiveDataHeader+'"]').closest('.swatchAccordionHeader').scrollIntoView({behaviour: "smooth",block:"start"});
  }

  // check if this group is loaded, and load in if not:
  if(document.getElementById("swatchGroup"+activeVariantID)) {
    updateActiveSwatchGroup(activeVariantID);
  } else {
    // store reference to the section:
    storedActiveVariantId = activeVariantID;
    if(usingAccordion) {
      document.querySelector('#accordionVariantWrapper .swatchAccordionHeader[data-label="'+storedActiveDataHeader+'"]').classList.add('loading');
    } else {
      document.getElementById('dynamicallyLoadedSwatchGroups').classList.add('loading');
    }
    // https://shopify.dev/docs/api/section-rendering#request-sections
    const request = new XMLHttpRequest();
    request.addEventListener('load', activeSwatchGroupResponse);
    request.open('GET', window.location.pathname + '?variant='+activeVariantID+'&sections=variant-swatch-group', true);
    request.send();
  }
}

function updateActiveSwatchGroup(activeVariantID) {

  clearSwatchPreview();

  var previousSelections = [];
  var i, j, swatchGroupInputs, previouslySelectedStep;
  var swatchGroups = document.querySelectorAll('.variantsSwatchGroups');
  var previouslySelectedActiveSwatches = document.querySelectorAll('.variantsSwatchGroups.active .swatchSelection.active');
  var wasFirstStepSelected = false;
  var wasSecondStepSelected = false;


  // check if any previously selected options match the new selected options and select those if so:
  if(previouslySelectedActiveSwatches != null) {
    for (j = 0; j < previouslySelectedActiveSwatches.length; j++) {
        previousSelections.push(previouslySelectedActiveSwatches[j].getAttribute('data-name'));
        previouslySelectedStep = previouslySelectedActiveSwatches[j].closest('.variantSwatchGroupWrapper').getAttribute('data-step');
        if(previouslySelectedStep == 1) {
          wasFirstStepSelected = true;
        }
        if(previouslySelectedStep == 2) {
          wasSecondStepSelected = true;
        }
    }
  }

  for (i = 0; i < swatchGroups.length; i++) {
    swatchGroups[i].classList.remove('active');
    // add disabled to activeSwatchChoice inputs so they don't get used
    swatchGroupInputs = swatchGroups[i].querySelectorAll('.activeSwatchChoice');
    for (j = 0; j < swatchGroupInputs.length; j++) {
      swatchGroupInputs[j].setAttribute('disabled', 'disabled');
    }
  }

  const targetElement = "swatchGroup"+activeVariantID;
  if(document.getElementById(targetElement)) {
    document.getElementById(targetElement).classList.add('active');
    // remove disabled from activeSwatchChoice inputs
    swatchGroupInputs = document.getElementById(targetElement).querySelectorAll('.activeSwatchChoice');
    for (j = 0; j < swatchGroupInputs.length; j++) {
      swatchGroupInputs[j].removeAttribute('disabled');
    }
    // look for .swatchSelection in this group and see if any match the previous selection:
    var thisGroupsSwatchSelections = document.getElementById(targetElement).querySelectorAll('.swatchSelection');
    var thisSwatchGroupsName;
    if(thisGroupsSwatchSelections != null) {
      for (j = 0; j < thisGroupsSwatchSelections.length; j++) {
        thisSwatchGroupsName = thisGroupsSwatchSelections[j].getAttribute('data-name');
        if(previousSelections.includes(thisSwatchGroupsName)) {
          // set value of activeSwatchChoice:
          thisGroupsSwatchSelections[j].closest('.variantSwatchGroupWrapper').querySelector('.activeSwatchChoice').value = thisSwatchGroupsName;
          thisGroupsSwatchSelections[j].classList.add('active');
        }

      }
    }
 
    if((activeStep > 3) && (wasFirstStepSelected) && (wasSecondStepSelected)) {
        // leave it as it is
    } else if((activeStep == 3) && (wasFirstStepSelected) && (wasSecondStepSelected)) {
        // step 1 and 2 options were both matched, so keep the customer on step 3:
        var allActiveSwatchGroups = document.querySelectorAll('.variantsSwatchGroups > .variantSwatchGroupWrapper');
        var i;
        for (i = 0; i < allActiveSwatchGroups.length; i++) {
          allActiveSwatchGroups[i].classList.remove('active');
        }
        document.querySelectorAll(('.variantsSwatchGroups.active > .variantSwatchGroupWrapper'))[2].classList.add('active');
        // clear any swatch selection in the step UI:
        document.querySelector('#stepProgress li.current').innerHTML = '3';
    } else if((activeStep == 2) && (wasFirstStepSelected)) {
        // the step 1 options were matched, so, can keep the customer on step 2:
        var allActiveSwatchGroups = document.querySelectorAll('.variantsSwatchGroups > .variantSwatchGroupWrapper');
        var i;
        for (i = 0; i < allActiveSwatchGroups.length; i++) {
          allActiveSwatchGroups[i].classList.remove('active');
        }
        document.querySelectorAll(('.variantsSwatchGroups.active > .variantSwatchGroupWrapper'))[1].classList.add('active');
        // clear any swatch selection in the step UI:
        document.querySelector('#stepProgress li.current').innerHTML = '2';
    } else {
      resetToFirstSwatchPanel();
    }
  }
}

function checkForDeliveryCharge(activeVariantID) {
  if(productDeliveryCharges.hasOwnProperty(activeVariantID)) {
    document.getElementById('productAdditionalDeliveryCharge').innerHTML = productDeliveryCharges[activeVariantID];
  }
}

function absoluteAccordionHeaderUpdated(newVariantId) {
  if(document.querySelector('.variantsSwatchGroups') != null) {
    loadActiveSwatchGroup(newVariantId);
  }
  if(document.getElementById('productLeadTime')) {
    checkForLeadTime(newVariantId);
  }
  if(document.getElementById('inStockLabel')) {
    checkForStockLevel(newVariantId);
  }
  if(document.getElementById('productAdditionalDeliveryCharge')) {
    checkForDeliveryCharge(newVariantId);
  } 
}

function absoluteVariantUpdated(newVariant) {
  if(newVariant) {
    if(typeof newVariant.id !== "undefined") {
      // called from product.js 
      if(document.querySelector('.variantsSwatchGroups') != null) {
        loadActiveSwatchGroup(newVariant.id);
      }
      if(document.getElementById('productLeadTime')) {
        checkForLeadTime(newVariant.id);
      }
      if(document.getElementById('inStockLabel')) {
        checkForStockLevel(newVariant.id);
      }
      if(document.getElementById('productAdditionalDeliveryCharge')) {
        checkForDeliveryCharge(newVariant.id);
      } 
    }
  }
}

function handleSwatchClick(e) {
  if(e) {
    e.preventDefault();
  }
  var thisParent = e.target.closest('.swatchSelection');

  var swatchSiblingSelectors = e.target.closest('.variantSwatchGroupWrapper').querySelectorAll('.swatchSelection');
  var i;
  for (i = 0; i < swatchSiblingSelectors.length; i++) {
    swatchSiblingSelectors[i].classList.remove('active');
  }

  thisParent.classList.add('active');
  // remove any errors on this section heading from it not being selected previously:
  e.target.closest('.variantSwatchGroupWrapper').querySelector('.form__label').classList.remove("error");
  e.target.closest('.variantSwatchGroupWrapper').querySelector('.activeSwatchChoice').value = thisParent.getAttribute('data-name');

  // give the classes time to populate:
  setTimeout(function(){
    updateSwatchPreview();
  }, 250);
}

function getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

function getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }

async function checkForFreeGiftProducts() {
  if(document.getElementById('freeGiftTimeStamp')) {
    var formData = {items: []}
    var timestamp = document.getElementById('freeGiftTimeStamp').value;
    for (let i = 0; i < freeGiftProducts.length; i++) {
        formData.items.push({
            'id': freeGiftProducts[i],
            'quantity': 1,
            'properties': {
                '_timestamp': timestamp,
                '_freegift': "true"
            }
        });
    }
    formData['sections'] = "main-cart,cart-drawer,cart-bubble";

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        },
        body: JSON.stringify(formData)
    })
    .then((response) => response.json())
    .then((response) => {
          if (response.status) {
            return;
          }

              // assign a new timestamp in case a second is added:
    document.getElementById('freeGiftTimeStamp').value = Date.now();

     getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(response.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(response);
        }
      }));



          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
          if (document.getElementById('Cart-Drawer')) {
            document.body.classList.add('open-cc');
            document.getElementById('Cart-Drawer').classList.add('active');
            dispatchCustomEvent('cart-drawer:open');
          }
        })
        .catch((e) => {
          console.error(e);
          document.getElementById('stringConfigErrorMessage').innerHTML = document.getElementById('stringConfigError').getAttribute("data-message");
          document.getElementById('stringConfigError').classList.add('active');
        });

  }        
}

function absoluteFilterClick(newQueryString) {
  // called from facet.js
  // update child category links with the new filter params:
  if (newQueryString != '') {
    newQueryString = '?'+newQueryString;
  }
  var childCategoryLink = document.querySelectorAll('.filterSubCategoryLink');
  var i;
  for (i = 0; i < childCategoryLink.length; i++) {
    childCategoryLink[i].href = childCategoryLink[i].getAttribute('data-root') + newQueryString;
  }
}


function forceDownload(blob, filename) {
  var a = document.createElement('a');
  a.download = filename;
  a.href = blob;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

function downloadResource(url, filename) {
  if (!filename) filename = url.split('\\').pop().split('/').pop().split('?').shift();
  fetch(url, {
      headers: new Headers({
        'Origin': location.origin
      }),
      mode: 'cors'
    })
    .then(response => response.blob())
    .then(blob => {
      let blobUrl = window.URL.createObjectURL(blob);
      forceDownload(blobUrl, filename);
    })
    .catch(e => console.error(e));
}

function forceDownloadClick(e) {
  if(e) {
    e.preventDefault();
  }
  //e.target.closest('a').classList.add('working');
  downloadResource(e.target.closest('a').getAttribute('href'));
}

// workaround for the download attribute only applying to same origin URLs and the file's being hosted on the CDN
const allDownloadButtons = document.querySelectorAll('.forceDownload');
if (allDownloadButtons.length > 0) {
  for (i = 0; i < allDownloadButtons.length; i++) {
    allDownloadButtons[i].onclick = forceDownloadClick;
  }
}

function checkProductSwatchValidation() {
  // called from product.js
  if(document.getElementById('variantModal')) {
    return modalOptionsSelected;
  } else {
    return true;
  }
}

/*
function showAllSwatches(e) {
  e.target.closest('.swatchListWrapper').classList.add('revealAll');
}
*/

function setUpSwatchClickHandlers() {
  // handles swatches being selected:
  var swatchSelectors = document.querySelectorAll('.swatchSelection');
  var i;
  for (i = 0; i < swatchSelectors.length; i++) {
    swatchSelectors[i].onclick = handleSwatchClick;
  }

  /*
  var showMoreButtons = document.querySelectorAll('.variantsSwatchGroups .swatchShowMore');
  var i;
  if(showMoreButtons) {
    for (i = 0; i < showMoreButtons.length; i++) {
      showMoreButtons[i].onclick = showAllSwatches;
    }
  }
  */
}

function handleAccordionHeaderClick(e) {
  if(e) {
    e.preventDefault();
  }
  let i;
  accordionHeaderClicked = true;
  // try and find the relevant option in the product selector and trigger that:
  const thisElement = e.target.closest('.swatchAccordionHeader');
  const thisLabel = thisElement.getAttribute('data-label');
  const variantSelectOptions = document.querySelector('#variantModal .variations select').options;
  if(variantSelectOptions) {
    for(i=0;i<variantSelectOptions.length;i++){
      if(variantSelectOptions[i].getAttribute('data-label') == thisLabel) {
        variantSelectOptions[i].selected = true;
        storedActiveDataHeader = thisLabel;
        absoluteAccordionHeaderUpdated(variantSelectOptions[i].getAttribute('data-variant'));
        // update product id and query in the URL etc:
       document.querySelector('variant-selects').dispatchEvent(new Event('change'));
      }
    }
  }  
}

function absoluteProductRecommendationsLoaded() {
  // called from app.js
    new SlideShow();  
}

function closeMiniCart(e) {
  if(e) {
    e.preventDefault();
  }
  document.getElementById('Cart-Drawer').classList.remove('active');
  document.body.classList.remove('open-cc');
}

if(document.querySelector('.variantsSwatchGroups') != null) {
  setUpSwatchClickHandlers();
}


if (document.querySelector('.simpleSwatchSelectionPreview') !== null) {
  const allSwatchLabels = document.querySelectorAll('.variations label.product-swatch-option');
  var i;
  for (i = 0; i < allSwatchLabels.length; i++) {
    allSwatchLabels[i].onclick = updateSimpleSwatchPreview;
    if(allSwatchLabels[i].previousElementSibling.checked) {
      setSimpleSwatchPreview(allSwatchLabels[i], allSwatchLabels[i].getAttribute('data-previewimage'));
    }
  }
}



if(document.getElementById('variantModal')) {
  modalOptionsSelected = false;
  activeStep = 1;
  checkForMultipleOptions();
  storedActiveVariantId = 0;
  storedActiveDataHeader = '';
  usingAccordion = false;
  accordionHeaderClicked = false;
  if(document.getElementById('variantModal').getAttribute('data-options') == "1") {
    usingAccordion = true;
  }
  document.getElementById('showVariantModal').onclick = showVariantModal;
  document.getElementById('hideVariantModal').onclick = hideVariantModal;
  document.getElementById('confirmVariantModal').onclick = confirmVariantModal;
  document.getElementById('nextStepVariantModal').onclick = nextStepVariantModal;
  document.getElementById('stepProgress').onclick = stepPaginationClick;

  var swatchAccordionSelectors = document.querySelectorAll('#accordionVariantWrapper .swatchAccordionHeader');
  var i;
  for (i = 0; i < swatchAccordionSelectors.length; i++) {
    swatchAccordionSelectors[i].onclick = handleAccordionHeaderClick;
  }

  setUpSwatchClickHandlers(); 
  // document.getElementById('clearVariantModal').onclick = clearVariantModal;
}

document.body.addEventListener( 'click', function (e) {
  if( event.target.id == 'productTemplateCartContinue' ) {
    // element gets replaced when the cart is redrawn:
//if(document.getElementById('productTemplateCartContinue')) {
  // document.getElementById('productTemplateCartContinue').onclick = closeMiniCart;
  closeMiniCart();
}
});
